import PropTypes from 'prop-types';
import { Box } from '@mui/material';

const IconFileGif = (props) => {
  const { fontSize = '1.5rem', color = 'text.disabled', filled = true, ...other } = props;

  if (!filled) {
    console.debug('IconFileGif needs to be created also as outlined icon');
  }

  return (
    <Box component="span" display="block" height={fontSize} width={fontSize} {...other}>
      <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M19.1429 4H4.85714C3.27857 4 2 5.27857 2 6.85714V16.8571C2 18.4357 3.27857 19.7143 4.85714 19.7143H19.1429C20.7214 19.7143 22 18.4357 22 16.8571V6.85714C22 5.27857 20.7214 4 19.1429 4ZM11.1071 12.1643C11.1071 12.7143 10.9929 13.1857 10.7571 13.5786C10.5286 13.9714 10.2071 14.2714 9.8 14.4857C9.39286 14.7 8.92857 14.8 8.40714 14.8C7.82143 14.8 7.30714 14.6714 6.86429 14.4143C6.42143 14.1571 6.07857 13.7857 5.82857 13.3071C5.58571 12.8286 5.45714 12.2571 5.45714 11.6C5.45714 11.0929 5.52857 10.6429 5.67857 10.25C5.82857 9.85 6.03571 9.51429 6.3 9.24286C6.56429 8.96429 6.87857 8.75714 7.22857 8.61429C7.57857 8.47143 7.96429 8.4 8.37857 8.4C8.72857 8.4 9.05714 8.45 9.36429 8.55714C9.67143 8.65714 9.93571 8.8 10.1714 8.99286C10.4071 9.17857 10.6 9.4 10.75 9.65714C10.9 9.91429 11 10.1929 11.0357 10.5H9.69286C9.65 10.35 9.59286 10.2214 9.51429 10.1071C9.43571 9.99286 9.34286 9.89286 9.22857 9.81429C9.12143 9.73571 8.99286 9.67143 8.85 9.62857C8.70714 9.58571 8.55714 9.56429 8.38571 9.56429C8.06429 9.56429 7.78571 9.64286 7.54286 9.8C7.3 9.95714 7.11429 10.1857 6.98571 10.4929C6.85 10.7929 6.78571 11.1571 6.78571 11.5929C6.78571 12.0286 6.85 12.3929 6.98571 12.7C7.11429 13.0071 7.30714 13.2357 7.54286 13.4C7.78571 13.5571 8.07143 13.6357 8.4 13.6357C8.7 13.6357 8.95 13.5857 9.16429 13.4786C9.37857 13.3714 9.54286 13.2214 9.65 13.0286C9.75714 12.8429 9.80714 12.6286 9.81429 12.3786H8.47857V11.3857H11.0857V12.1714L11.1071 12.1643ZM13.4143 14.7143H12.0929V8.47857H13.4143V14.7143ZM18.6214 9.56429H15.8143V11.05H18.35V12.1357H15.8143V14.7143H14.4929V8.47857H18.6214V9.56429Z"
          fill={color}
        />
      </svg>
    </Box>
  );
};

IconFileGif.propTypes = {
  color: PropTypes.string,
  filled: PropTypes.bool,
  fontSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default IconFileGif;
